<template>
    <div>
        <div class="mt-5 centerLoadingBar" v-if="isLoading">
            <b-spinner type="grow" label="Spinning"></b-spinner>
        </div>
        <div v-else class="divCenter">
            <h4 class="mb-3">Upload Einstellungen</h4>
            <SkuAlias/>
            <form>
                <hr>
                <p class="mt-2 lead">Material bearbeiten</p>
                <div>
                    <div>
                        <b-dropdown text="Material auswählen" class="m-md-2 hl-dropdown">
                            <b-dropdown-item-button @click="materialSelectionChanged" :key="item.materialName + index"
                                                    v-for="(item, index) in materials">{{item.materialName}}
                            </b-dropdown-item-button>
                        </b-dropdown>

                        <button class=" float-right  btn btn-dark mt-4 m-md-2" v-b-tooltip.hover v-b-modal.modal-new-material title="Neues Material hinzufügen"><b-icon icon="plus-circle-fill"></b-icon></button>

                        <b-modal hide-footer id="modal-new-material" size="xl" title="Neues Material hinzufügen">

                            <b-container fluid>

                                <b-row class="my-1">
                                    <b-col sm="4">
                                        <label for="newMaterialID">Material (ID)</label>
                                    </b-col>
                                    <b-col sm="8">
                                        <b-form-input v-model="newMaterial.material" id="newMaterialID" size="sm"
                                                      type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="4">
                                        <label for="newmaterialNameID">Material Name</label>
                                    </b-col>
                                    <b-col sm="8">
                                        <b-form-input v-model="newMaterial.materialName" id="newmaterialNameID" size="sm"
                                                      type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="4">
                                        <label for="newParentSKU">SKU</label>
                                    </b-col>
                                    <b-col sm="8">
                                        <b-form-input id="newParentSKU" size="sm" type="text"
                                                      v-model="newMaterial.parentSKU"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-container>

                            <button class="w-25  btn btn-dark mt-4 m-md-2" @click.prevent="createNewMaterial">Material erstellen</button>



                            <!--                            <div v-for="(item, index) in selectedMaterial.bulletPoints" :key="index" class="input-group mt-1">-->
                            <!--                                <input type="text" class="form-control" v-model="selectedMaterial.bulletPoints[index]">-->

                            <!--                                <button type="button" class="btn btn-danger" @click="selectedMaterial.bulletPoints.splice(index, 1)">Löschen</button>-->
                            <!--                            </div>-->
                            <!--                            <div class="input-group w-25 mt-3">-->
                            <!--                                <input type="text" class="form-control" v-model="bulletPointAdd">-->

                            <!--                                <div class="input-group-append">-->
                            <!--                                    <b-button class="btn btn-outline-light" type="button" @click="addBulletPoint">hinzufügen</b-button>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                        </b-modal>

                        {{this.selectedMaterial.materialName}}
                    </div>


                    <div class="mt-3" v-if="selectedMaterial._id">

                        <MaterialData :selected-material="selectedMaterial" :uploadSizes="upload_sizes"/>

                    </div>

                </div>


                <button v-if="selectedMaterial._id" class="w-25  btn btn-dark mt-4 m-md-2" @click.prevent="saveData">Aktualisieren</button>
                <button v-if="selectedMaterial._id" class="w-25  btn btn-dark mt-4 m-md-2" @click.prevent="downloadParentFile">Parent Vorlage herunterladen</button>
<!--                <button v-if="selectedMaterial._id"-->
<!--                        class="float-right btn btn-dark mt-4 m-md-2"-->
<!--                        v-b-tooltip.hover-->
<!--                        v-b-modal.modal-deleteMaterial-->
<!--                        title="Material löschen"><b-icon icon="trash"/></button>-->

<!--                                <b-modal ref="my-modal" hide-footer id="modal-deleteMaterial" size="xl" title="Material löschen">-->
<!--<div>-->
<!--                                    Möchten Sie das Material <b>{{selectedMaterial.materialName}}</b> und alle dazugehörigen Einstellungen dauerhaft löschen?-->
<!--</div>-->

<!--                                    <button class="w-25 btn btn-danger mt-5 m-md-2" @click.prevent="deleteMaterial">Ja</button>-->
<!--                                    <button class="w-25 btn btn-dark mt-5 m-md-2" @click="hideModalDelete">Abbrechen</button>-->
<!--                                </b-modal>-->

            </form>
        </div>
    </div>


</template>


<script>

    import Api from './api'
    import SkuAlias from './components/SkuAlias'
    import MaterialData from './components/MaterialData'
    import XLSX from 'xlsx'
    import {createParentLineForFile} from './utils.mjs'
    export default {
        components:{
            SkuAlias,
            MaterialData
        },

        data() {
            return {
                addOriginalSKU: '',
                materials: [],
                upload_sizes: {},
                addReplacedSKU: '',
                skuReplacementList: [],
                selectedMaterial: {},
                isLoading: false,
                newMaterial: {},
                parentLine: {},
                columns:[
                    {
                        key:'original',
                        label:"Original"

                    },
                    {
                        key: 'replaced',
                        label:"Ersetzt"
                    },
                    { key: 'actions', label: 'Actions' }
                ]
            }
        },
        methods: {

            deleteSKURepl(item){
                if(item._id){
                    Api.sku.deleteSKUReplacement(item._id)
                        .then(res => {
                            if(res.status !== 200){
                                throw new Error("Fehler beim Löschen")
                            }
                            this.makeToast('success', 'SKU Alias ' + item.original + ' wurde erfolgreich gelöscht.', 'Erfolgreich')


                        })
                        .catch(e => {
                            this.makeToast('danger', 'SKU Alias ' + item.original + ' konnte nicht gelöscht werden Fehler: ' + e.message, 'Fehler')

                        })
                }
            },

            deleteMaterial(){
                let that = this;
                if(this.selectedMaterial && this.selectedMaterial._id){
                        this.isLoading = true;
                    Api.materials.deleteMaterial(this.selectedMaterial)
                        .then(result => {
                            if(result.status !== 200) throw new Error("Interner Server Fehler")
                            this.isLoading = false
                            this.makeToast('success', 'Material ' + that.newMaterial.materialName + ' wurde erfolgreich gelöscht.', 'Erfolgreich')

                        })
                        .catch( e => {
                            this.makeToast('success', 'Material ' + that.newMaterial.materialName + ' konnte nicht gelöscht werden. Fehler: ' + e.message, 'Fehler')

                        })

                }
            },


            hideModalDelete(){
                this.$refs['my-modal'].hide()

            },

            createNewMaterial(){
                this.isLoading = true
                var that = this
                if(this.newMaterial && this.newMaterial.material && this.newMaterial.materialName && this.newMaterial.parentSKU){
                    Api.materials.createMaterial(this.newMaterial)
                        .then(result => {
                            if (result.status === 200) {


                                this.loadMaterials()
                                this.isLoading = false
                                this.makeToast('success', 'Material ' + that.newMaterial.materialName + ' wurde erfolgreich erstellt.', 'Erfolgreich')
                                that.newMaterial = {}

                            } else {
                                this.makeToast('danger', 'Material ' + that.newMaterial.materialName + ' konnte nicht erstellt werden.', 'Fehler')
                                this.isLoading = false
                            }
                        })
                        .catch(e => {
                            this.isLoading = false
                            this.makeToast('danger', 'Material ' + that.newMaterial.materialName + ' konnte nicht erstellt werden. Fehler: ' + e.message, 'Fehler')
                        })

                }else{
                    this.isLoading = false
                    this.makeToast('danger', 'Material ' + that.newMaterial.materialName + ' konnte nicht erstellt werden.', 'Fehler')

                }
            },

            saveData() {
                this.isLoading = true;
                console.log(this.selectedMaterial)
                let that = this;
                Api.materials.updateMaterial(this.selectedMaterial)
                    .then(result => {
                        if (result.status === 200) {


                            this.loadMaterials()
                            this.isLoading = false
                            this.makeToast('success', 'Material ' + that.selectedMaterial.materialName + ' wurde erfolgreich aktualisiert.', 'Erfolgreich')
                            // this.selectedMaterial = {}
                            // this.selectedMaterialTxt = ''

                        } else {
                            this.makeToast('danger', 'Material ' + that.selectedMaterial.materialName + ' konnte nicht aktualisiert werden.', 'Fehler')
                            // this.eanAdd = ''
                            this.isLoading = false
                        }
                    })
                    .catch(e => {
                        this.makeToast('danger', 'Material ' + that.selectedMaterial.materialName + ' konnte nicht aktualisiert werden.\nFehler: ' + e.message, 'Fehler')
                        this.isLoading = false
                    })

            },

            downloadParentFile() {
                this.isLoading = true;
                try {
                    const basisData = {
                        // feed_product_type: "cellularphonecase",
                        parent: "Parent",
                        update_delete: "Aktualisierung",
                    };

                    let reader = new FileReader();
                    var that = this;
                    reader.addEventListener("load", e => {
                        let workbook = XLSX.read(e.target.result, {type: 'binary'})
                        workbook.SheetNames.forEach(function (sheetName) {

                            let fileJSON = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName], {
                                range: 2,
                                blankrows: true,
                                defval: ""
                            });

                            let currObj = {}
                            Object.assign(currObj, fileJSON[0])
                            let keys = Object.keys(that.parentLine);

                            for (let key of keys) {
                                currObj[key] = that.parentLine[key];
                            }

                            XLSX.utils.sheet_add_json(workbook.Sheets[sheetName], [currObj], {origin: "A3"})
                            // that.globalWorkbook = workbook

                            XLSX.writeFile(workbook, 'parentFile.txt', {bookType:"csv", FS:"\t"});
                            that.isLoading = false;


                        })
                    })

                    createParentLineForFile(basisData, this.selectedMaterial)

                        .then(x => {
                            that.parentLine = x;
                            return Api.download.downloadTemplateFile()
                        })
                        .then(response => {
                            return response.data
                        })
                        .then(blob => {
                            var file = new File([blob], `UPLOAD.xlsx`);
                            reader.readAsBinaryString(file)
                            that.isLoadingData = false
                        }).catch(e => {
                        this.makeToast('danger', "Fehler: " + e.message, "Fehler beim Laden")
                        that.isLoading = false;

                    });
                }catch (e) {
                    this.makeToast('danger', "Fehler: " + e.message, "Fehler beim Erstellen")
                    that.isLoading = false;

                }
            },

            makeToast(variant = null, body = '', title = '') {
                this.$bvToast.toast(body, {
                    title: title,
                    variant: variant,
                    solid: true
                })
            },

            materialSelectionChanged(e) {
                // this.selectedMaterialTxt = e.target.outerText;
                this.selectedMaterial = this.materials.find(item => item.materialName == e.target.outerText)

            },

            addSKU() {
                if (this.addOriginalSKU.length !== 0) {

                    Api.sku.pushSKUReplacement({original: this.addOriginalSKU, replaced: this.addReplacedSKU})
                        .then(result => {
                            if (result.status === 200) {
                                this.makeToast('success', 'SKU Abkürzung wurde erfolgreich hinzugefügt', 'Erfolgreich')
                                this.addOriginalSKU = ''
                                this.addReplacedSKU = ''
                                this.loadSKUReplacements()
                            } else {
                                this.makeToast('danger', 'SKU Abkürzung konnte nicht hinzugefügt werden', 'Fehler')
                                // this.eanAdd = ''
                            }
                        })
                        .catch(e => {
                            this.makeToast('danger', 'SKU Abkürzung konnte nicht hinzugefügt werden.\nFehler: ' + e.message, 'Fehler')

                        })
                } else {
                    this.makeToast('warning', 'Originaltext oder Abkürzung ist leer (min. 1 Zeichen erforderlich).', 'Warnung')

                }
            },


            loadSKUReplacements() {
                Api.sku.getSKUReplacements()
                    .then(data => data.data)
                    .then(data => {
                        this.skuReplacementList = data
                    })
                    .catch((e) => {
                        this.skuReplacementList = []
                        this.makeToast("danger", e.message ? e.message : "Fehler", "Fehler beim SKU Abruf")
                    })
            },

                    loadMaterials() {
                        let that = this
                        Api.materials.getMaterials()
                            .then(response => response.data)
                            .then(data => {
                                that.materials = data
                                return Api.upload_sizes.getAllSizes()
                            })
                            .then(res => res.data)
                            .then(data => {
                                console.log("Data in uploadSettings")
                                console.log(data)
                                that.upload_sizes = data
                            })
                            .catch((e) => {
                                this.skuReplacementList = []
                                this.makeToast("danger", e.message ? e.message : "Fehler", "Fehler beim SKU Abruf")
                            })
                    }

    }
    ,
    beforeMount() {
        console.warn("Before mount")
        let jwt = this.$cookies.get("authToken")
        // console.log(jwt)

        var that = this
        Api.auth.verify({authToken: jwt})

            .then(response => {
                if (response.status == 200) {
                    this.$store.commit('setUser', true);
                    Api.init(jwt);
                    try {
                        this.loadMaterials()
                    } catch (e) {
                        console.log(e)
                        console.log("Could not load SKU replacements.")
                    }
                    that.loadMaterials()
                    // that.loadSKUReplacements()
                }
            })
            .catch(() => {
                this.$store.commit('setUser', false)
                this.$router.push({path: '/'})
            })
    }

    }
</script>

<style>
    .hl-dropdown {
        width: 200px;
    }

    .divCenter {
        padding-top: 20px;
        margin-left: 20%;
        margin-right: 20%;
    }


    .table-condensed {
        font-size: 12px;
    }

    /*.addButton {*/
    /*    font-size: 50px;*/
    /*    padding: 0px 0px 0px 0px;*/
    /*}*/

</style>
